import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { ModulePermissionService } from './services/module-permission.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { firstValueFrom } from 'rxjs';

export const modulePermissionGuard = (moduleId: number, editorOnly: boolean = false): CanActivateFn => async (route, state): Promise<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const service: ModulePermissionService = inject(ModulePermissionService);
  const auth: AuthenticationService = inject(AuthenticationService);

  let response: { hasPermission: boolean };

  if(editorOnly) {
    response = await firstValueFrom(service.hasEditorPermission(moduleId));
  } else {
    response = await firstValueFrom(service.hasViewerPermission(moduleId));
  }

  if(auth.user().is_super_admin) {
    return true;
  }

  if (response.hasPermission) 
    return true;
  else 
    return router.createUrlTree(['/dashboard']);
};
